import { Component, Input } from '@angular/core';
import { NgForage } from 'ngforage';
import AssetHelper from '../../../../../helpers/asset-helper';
import Asset from '../../../../../model/asset';
import { SignAsset } from '../../../../../model/sign/sign-asset';
import { SignDetail } from '../../../../../model/sign/sign-detail';
import { ModalService } from '../../../../../services/modal.service';
import { SnackService } from '../../../../../services/snack.service';
import { FileHelper } from '../../../../../helpers/file-helper';

@Component({
  selector: 'sign-detail-examples',
  templateUrl: './sign-detail-examples.component.html',
  styleUrls: ['./sign-detail-examples.component.scss'],
})
export class SignDetailExamplesComponent {
  @Input()
  sign: SignDetail;
  isImage = FileHelper.isImage;
  constructor(
    private modalService: ModalService,
    private snackService: SnackService,
    private ngForage: NgForage
  ) {}

  getAssetClass(signAsset: SignAsset, first: boolean): string {
    if (!signAsset.archived) {
      return first ? 'loadedImg' : 'loadedImg asset-left-space';
    }
    return '';
  }

  shortenName(name: string) {
    name = name.trim().replace(' ', '');
    let result = name.trim().replace(' ', '');
    let split = name.split('.');
    if (split.length > 1) {
      if (name.length > 8) {
        result =
          split[0].substring(0, 9 - split[split.length - 1].length) +
          '...' +
          split[split.length - 1];
      }
    }
    return result;
  }

  removeOnlineFile(item: SignAsset, index: number): void {
    this.modalService.confirmDialog(
      'Bestand verwijderen',
      'Bent u zeker dat u dit bestand wilt verwijderen?',
      (b: boolean) => {
        if (b) {
          this.sign.examples.splice(index, 1);
          this.snackService.showSuccess(
            'Bestand zal verwijderd worden tijdens opslaan'
          );
        }
      }
    );
  }

  removeOfflineFile(item: Asset, index: number) {
    this.modalService.confirmDialog(
      'Bestand verwijderen',
      'Bent u zeker dat u dit bestand wilt verwijderen?',
      (b: boolean) => {
        if (b) {
          this.sign.offlineExamples.splice(index, 1);
          this.ngForage.removeItem(
            AssetHelper.getStorageKeyFor(item.localFileUuid)
          );
          this.snackService.showSuccess('Bestand succesvol verwijderd');
        }
      }
    );
  }

  onAssetsAdded(assets: Asset[]): void {
    if (!this.sign.offlineExamples) {
      this.sign.offlineExamples = [];
    }
    assets.forEach((a) => {
      this.sign.offlineExamples.push(a);
    });
  }
}
